<!--
 * @Author: cryi.liu
 * @Date: 2020-04-30 09:35:30
 * @LastEditTime: 2020-06-09 16:10:19
 * @Description: VUE 根入口
 -->
<template>
  <div id="saec">
    <template v-if="layout === 'pss'">
      <pss-layout>
        <router-view />
      </pss-layout>
    </template>
    <template v-else-if="layout === ''">
      <router-view />
    </template>
  </div>
</template>

<script>
import PssLayout from './layouts/pss/Index.vue';

export default {
  name: 'Saec',
  components: {
    PssLayout,
  },
  computed: {
    layout() {
      return this.$route.meta.layout;
    },
  },
};
</script>

<style lang="less" scoped>
#saec {
  width: 100%;
  height: 100%;
}
</style>
